import { selectAll } from "d3";
import { setColorScale } from "./colors";
import {
  createSvg,
  addTooltip,
  GTExHeatmapConfig,
  drawColorLegend,
} from "./helpers";
import { draw } from "./draw";

export const createGTExHeatmap = (heatmapData, uniqueKey, containerWidth) => {
  const {
    marginL,
    marginR,
    marginB,
    marginT,
    height,
    colorScheme,
    rowLabelWidth,
    columnLabelHeight,
    columnLabelAngle,
    columnLabelPosAdjust,
    legendName,
    r,
  } = GTExHeatmapConfig;

  const id = `GTEx_Heatmap_${uniqueKey}`;
  const tissuesNum = 54;
  const colsNum = heatmapData ? heatmapData.length / tissuesNum : 0;
  const cellWidth = colsNum <= 4 ? 90 : 24;
  const width =
    colsNum <= 4
      ? colsNum * cellWidth + (marginL + marginR + rowLabelWidth)
      : colsNum * cellWidth;
  const containerW =
    colsNum <= 4
      ? Math.min(width, containerWidth)
      : Math.max(width, containerWidth);
  const inWidth = containerW - (marginL + marginR + rowLabelWidth);
  const inHeight = height - (marginT + marginB + columnLabelHeight);
  const newHeatmapData = heatmapData.map((d) => d.value);
  const colorScale = setColorScale(newHeatmapData, colorScheme, 0);

  selectAll(`#${id} > svg`).remove();

  // Create the SVG.
  const margin = {
    top: marginT,
    right: marginR,
    bottom: marginB,
    left: marginL,
  };
  const svg = createSvg(id, containerW, height, margin);

  // Add the tooltip.
  const tt = addTooltip(id);

  // Render the GTEx heatmap.
  draw(
    svg,
    { w: inWidth, h: inHeight },
    columnLabelAngle,
    false,
    columnLabelPosAdjust,
    heatmapData,
    tt,
    colorScale,
    r,
    rowLabelWidth
  );

  // Add color legend for the GTEx heatmap.
  const legendWidth = Math.min(containerW, 450) - 170;
  drawColorLegend(legendName, svg, colorScale, { x: 140, y: -40 }, 5, {
    h: 10,
    w: legendWidth / 5 - 5,
  });
};
